import React from "react";
import { Link, useLocation } from "react-router-dom";
import { getPageConfig } from "../components/portal/portalData";

const statusClass = (value) => {
  const label = String(value).toLowerCase();
  if (label.includes("approved") || label.includes("active") || label.includes("completed")) return "status-ok";
  if (label.includes("pending") || label.includes("draft")) return "status-warn";
  return "status-neutral";
};

const PortalPage = ({ page }) => {
  const location = useLocation();
  const config = getPageConfig(page);
  const chips = (config.chips || []).map((chip) =>
    typeof chip === "string" ? { label: chip, path: null } : { label: chip.label, path: chip.path || null }
  );

  return (
    <div className="portal-page">
      <section className="hero-card">
        <div className="hero-copy">
          <div className="eyebrow">BESarawak Staff Portal</div>
          <h2>{config.title}</h2>
          <p>{config.subtitle}</p>
          <div className="chip-row">
            {chips.map((chip) =>
              chip.path ? (
                <Link key={`${chip.label}-${chip.path}`} to={chip.path} className="chip chip-link">
                  {chip.label}
                </Link>
              ) : (
                <span key={chip.label} className="chip">
                  {chip.label}
                </span>
              )
            )}
          </div>
        </div>
        <div className="hero-visual">
          <div className="hero-orb" />
          <div className="hero-stat">
            <span>Route</span>
            <strong>{location.pathname}</strong>
          </div>
        </div>
      </section>

      <section className="metric-grid">
        {(config.metrics || []).map((metric) => (
          <article key={metric.label} className="metric-card">
            <span>{metric.label}</span>
            <strong>{metric.value}</strong>
            <p>{metric.note}</p>
          </article>
        ))}
      </section>

      <section className="panel-grid">
        {(config.panels || []).map((panel) => (
          <article key={panel.title} className="panel-card">
            <div className="panel-head">
              <h3>{panel.title}</h3>
              <span>{panel.rows.length} rows</span>
            </div>
            <div className="table-wrap">
              <table>
                <tbody>
                  {panel.rows.map((row, index) => (
                    <tr key={`${panel.title}-${index}`}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className={cellIndex === row.length - 1 ? statusClass(cell) : ""}>
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
};

export default PortalPage;
